import React from 'react'

export const ToolsIcon = () => (
  <svg
    width="47"
    height="47"
    viewBox="0 0 47 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.71333 1.22267C8.49209 0.587962 10.4216 0.507815 12.2468 0.992817C14.0721 1.47782 15.7073 2.50515 16.9364 3.93909C18.1655 5.37303 18.9306 7.14611 19.1308 9.02409C19.3309 10.9021 18.9566 12.7966 18.0573 14.4573L46.6147 43.0173L42.844 46.788L14.284 18.228C12.6229 19.1237 10.7293 19.4952 8.85288 19.2933C6.97645 19.0915 5.2052 18.3259 3.77255 17.0974C2.33991 15.8688 1.3131 14.2351 0.827445 12.4114C0.341789 10.5877 0.420077 8.65966 1.05199 6.88134L7.01732 12.8467C7.38631 13.2287 7.82769 13.5334 8.31571 13.7431C8.80372 13.9527 9.3286 14.0631 9.85972 14.0677C10.3908 14.0723 10.9176 13.9711 11.4091 13.77C11.9007 13.5688 12.3473 13.2718 12.7229 12.8963C13.0985 12.5207 13.3955 12.0741 13.5966 11.5825C13.7977 11.0909 13.8989 10.5642 13.8943 10.0331C13.8897 9.50195 13.7794 8.97707 13.5697 8.48905C13.3601 8.00104 13.0554 7.55966 12.6733 7.19067L6.71066 1.22L6.71333 1.22267ZM34.3587 6.24667L42.844 1.532L46.6147 5.30267L41.9 13.788L37.1853 14.732L31.532 20.388L27.7587 16.6173L33.4147 10.9613L34.3587 6.24667ZM16.444 27.932L20.2147 31.7027L6.07333 45.844C5.59252 46.3262 4.94549 46.6061 4.26487 46.6265C3.58426 46.6469 2.92163 46.4062 2.41283 45.9536C1.90404 45.5011 1.58763 44.8711 1.52847 44.1927C1.46931 43.5144 1.67188 42.8391 2.09466 42.3053L2.30266 42.0733L16.444 27.932Z"
      fill="#00a3ff"
    />
  </svg>
)

export const DatabaseIcon = () => (
  <svg
    width="49"
    height="52"
    viewBox="0 0 49 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83333 25.8333C5.83333 26.668 7.06267 28.1213 9.91333 29.548C13.604 31.3933 18.8387 32.5 24.5 32.5C30.1613 32.5 35.396 31.3933 39.0867 29.548C41.9373 28.1213 43.1667 26.668 43.1667 25.8333V20.044C38.7667 22.764 32.0387 24.5 24.5 24.5C16.9613 24.5 10.2333 22.7613 5.83333 20.044V25.8333ZM43.1667 33.3773C38.7667 36.0973 32.0387 37.8333 24.5 37.8333C16.9613 37.8333 10.2333 36.0947 5.83333 33.3773V39.1667C5.83333 40.0013 7.06267 41.4547 9.91333 42.8813C13.604 44.7267 18.8387 45.8333 24.5 45.8333C30.1613 45.8333 35.396 44.7267 39.0867 42.8813C41.9373 41.4547 43.1667 40.0013 43.1667 39.1667V33.3773ZM0.5 39.1667V12.5C0.5 5.87333 11.2467 0.5 24.5 0.5C37.7533 0.5 48.5 5.87333 48.5 12.5V39.1667C48.5 45.7933 37.7533 51.1667 24.5 51.1667C11.2467 51.1667 0.5 45.7933 0.5 39.1667ZM24.5 19.1667C30.1613 19.1667 35.396 18.06 39.0867 16.2147C41.9373 14.788 43.1667 13.3347 43.1667 12.5C43.1667 11.6653 41.9373 10.212 39.0867 8.78533C35.396 6.94 30.1613 5.83333 24.5 5.83333C18.8387 5.83333 13.604 6.94 9.91333 8.78533C7.06267 10.212 5.83333 11.6653 5.83333 12.5C5.83333 13.3347 7.06267 14.788 9.91333 16.2147C13.604 18.06 18.8387 19.1667 24.5 19.1667Z"
      fill="#00a3ff"
    />
  </svg>
)

export const CodeIcon = () => (
  <svg
    width="65"
    height="48"
    viewBox="0 0 65 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M64.5 24L49.4147 39.0853L45.644 35.3147L56.9587 24L45.644 12.6853L49.4147 8.91467L64.5 24ZM8.04133 24L19.356 35.3147L15.5853 39.0853L0.5 24L15.5853 8.91467L19.3533 12.6853L8.04133 24ZM26.6013 48H20.9267L38.3987 0H44.0733L26.6013 48Z"
      fill="#00a3ff"
    />
  </svg>
)
